<!--
 * @Author: likk
 * @Date: 2023-09-05 14:59:22
 * @LastEditTime: 2024-03-22 03:54:41
 * @LastEditors: likk 1126919170@qq.com
 * @Description: 添加/编辑农机弹框
-->
<template>
  <el-dialog :title="title" :visible.sync="visible" width="720px" :destroy-on-close="true" :before-close="handleClose" class="dialog-bg" :close-on-click-modal="false">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
    <el-row>
      <el-col :span="15">
          <el-form-item prop="checkedMachine" label="机具类型">
            <el-cascader ref="elCascader" :options="categories" :props="cateProps" v-model="form.checkedMachine" placeholder="请选择机具类型" @change="machineChange"></el-cascader>
          </el-form-item>
          <el-form-item prop="brandName" label="品牌">
            <el-autocomplete v-model="form.brandName" :fetch-suggestions="brandAssociate" placeholder="请输入"
              label="name" value="id" value-key="name" :trigger-on-focus="false"></el-autocomplete>
          </el-form-item>
          <el-form-item prop="companyName" label="生产企业">
            <el-autocomplete v-model="form.companyName" :fetch-suggestions="companyAssociate" placeholder="请输入" 
              label="name" value="id" value-key="name" :trigger-on-focus="false" @select="companyChange"></el-autocomplete>
          </el-form-item>
          <el-form-item prop="modelName" label="型号">
            <el-autocomplete v-model="form.modelName" :fetch-suggestions="modelAssociate" placeholder="请输入" 
              label="model" value="id" value-key="model" ></el-autocomplete>
          </el-form-item>
          <el-form-item prop="buyDate" label="购机日期">
            <el-date-picker v-model="form.buyDate" type="date" placeholder="请选择" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
          <el-form-item prop="factoryCode" label="出厂编号">
            <el-input v-model="form.factoryCode" placeholder="请输入"></el-input>
          </el-form-item>
      </el-col>
      <el-col :span="9">
        <el-form-item prop="machinePhotos">
        <el-upload
          class="upload-box"
          :action="'#'"
          accept="image/jpeg,image/gif,image/png"
          :multiple="false"
          :show-file-list="false"
          list-type="picture-card"
          :data="{ xtype: 'ysb_product', type: 'image' }"
          :on-success="handleImgSuccess"
          :http-request="handleCustomUpload"
        >
          <img class="thumb" v-if="form.machinePhotos" :src="form.machinePhotos"/>
          <template v-else>
            <i class="el-icon-plus"></i>
            <span>机具照片</span>
          </template>
        </el-upload>
      </el-form-item>
      </el-col>
    </el-row>
    </el-form>
    <div class="foot">
      <el-button type="primary" @click="handleSave()">确认</el-button>
      <el-button type="primary" class="btn-gray" @click="handleClose()">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { uploadImg } from "@/api/uploadImg";
  import { machineTypeTree,brandAssociate,companyAssociate,modelByComId } from "@/api/gxInfo";
  export default {
    props:{
      machineInfo:{
        type: Object,
        // eslint-disable-next-line vue/require-valid-default-prop
        default: {}
      }
    },
    watch:{
      machineInfo:{
        handler(val){
          if(Object.keys(val).length>0){
            this.form = JSON.parse(JSON.stringify(val));
            this.title = '编辑农机信息';
            this.form.checkedMachine = [`${val.firstMachineId}`,`${val.secondMachineId}`,`${val.machineId}`];
          }
        },
        deep:true,
        immediate:true
      },
      'form.companyName':{
        handler(val){
          val && this.getModelByComId();
        },
        deep:true,
        immediate:true
      },
      'form.checkedMachine':{
        handler(val){
          val && this.getModelByComId();
        },
        deep:true,
        immediate:true
      }
    },
    data(){
      var checkFactoryCode = (rule, value, callback) => {
        // eslint-disable-next-line no-useless-escape
        var reg1 = /^[0-9a-zA-Z\-\.\*\<\>\(\)\（\）]{1,40}/;
        var reg2 = /^[a-zA-Z0-9_]+$/;
        if (!value) {
          callback(new Error('请输入出厂编号'));
        }else if(!reg1.test(value) || !reg2.test(value)){
          callback(new Error('出厂编号格式不正确'));
        }else{
          callback()
        }
      }
      return {
        visible:true,
        title:'添加农机信息',
        form:{
          checkedMachine:[],
          brandName:"",
          companyName:'',
          modelName:"",
          buyDate:"",
          factoryCode:"",
          machinePhotos:"",
        },
        rules:{
          checkedMachine:{required: true, message: '请选择机具类型', trigger: 'change' },
          brandName:{required: true, message: '请输入品牌', trigger: 'change'},
          companyName:{required: true, message: '请输入生产企业', trigger: 'change'},
          modelName:{required: true, message: '请输入型号', trigger: 'change'},
          buyDate:{required: true, message: '请选择购机日期', trigger: 'change'},
          factoryCode:{validator: checkFactoryCode, trigger: 'blur'},
          machinePhotos:{required: true, message: '请上传机具照片', trigger: 'change'},
        },
        brandList:[],//品牌
        categories:[],//机具类型
        cateProps:{
          label:'n',
          value:'i'
        },
        companyList:[],//企业
        modelList:[],//型号
        loading:false,
        pickerOptions:{
          disabledDate:(time) => {
            return time.getTime() > Date.now()
          }
        }
      }
    },
    created(){
      // this.getBrands();
      this.getCategories();
    },
    methods:{
    /**
     * @Author: likk
     * @description: 获取品牌数据
     * @param {*}
     * @return {*}
     */  
    // async getBrands(){
    //   this.brandList = await brandList();
    // },   
    /**
     * @Author: likk
     * @description: 品牌名称联想
     * @param {*}
     * @return {*}
     */  
    brandAssociate(keyword,cb){
      if (keyword !== '') {
        this.loading = true;
        brandAssociate({keyword}).then( res => {
          this.loading = false;
          cb(res.data.result)
          this.brandList = res;
        }).catch( () => {
          this.loading = false;
        })
      } else {
        this.brandList = [];
      }
    },
    /**
     * @Author: likk
     * @description: 获取机具类型
     * @param {*}
     * @return {*}
     */  
     async getCategories(){
      const { data: {result} } = await machineTypeTree();
      this.categories = result;
    },
    /**
     * @Author: likk
     * @description: 获取生产企业数据
     * @param {*}
     * @return {*}
     */
     companyAssociate(keyword,cb) {
      if (keyword !== '') {
        this.loading = true;
        companyAssociate({keyword}).then( res => {
          this.loading = false;
          cb(res.data.result)
          this.companyList = res;
        }).catch( () => {
          this.loading = false;
        })
      } else {
        this.companyList = [];
      }
    },
    
    /**
     * @Author: likk
     * @description: 匹配型号数据
     * @param {*}
     * @return {*}
     */    
     modelAssociate(keyword, cb) {
      let result = [];
      if(!keyword){
        result = this.modelList;
      }else{
        result = this.modelList.filter( item => (item.model.indexOf(keyword)>-1))
      }
      cb(result)
      },
    /**
     * @Author: likk
     * @description: 生产企业选择值改变
     * @param {*}
     * @return {*}
     */ 
    companyChange(){
      this.form.modelName = '';
      this.modelList = [];
    },
    /**
     * @Author: likk
     * @description: 机具分类选择值切换
     * @param {*}
     * @return {*}
     */
    machineChange(){
      this.form.modelName = '';
      this.modelList = [];
    },    
    /**
     * @Author: likk
     * @description: 根据生产企业id及机具分类id获取型号数据
     * @param {*}
     * @return {*}
     */ 
    async getModelByComId(){
      let companyItem = this.companyList.find(item => item.name==this.form.companyName);
      if(!this.form.companyName || !companyItem) return false;//生产企业必选
      const { data: {result} } = await modelByComId({
        companyId:companyItem.id,
        categoryId1:this.form.checkedMachine[0] || '',
        categoryId2:this.form.checkedMachine[1] || '',
        categoryId3:this.form.checkedMachine[2] || '',
        categoryId4:this.form.checkedMachine[3] || '',
      }) || [];
      this.modelList = result;
    },   
    /**
     * @Author: likk
     * @description: 自定义上传
     * @param {*}
     * @return {*}
    */ 
    handleCustomUpload(content) {
      uploadImg(content).then((res) => {
          content.onSuccess(res.data);
        }).catch((err) => {
          content.onError(err);
          this.$message.error("服务器异常，请重新上传");
        });
    },
    /**
     * @Author: likk
     * @description: 上传成功
     * @param {*}
     * @return {*}
    */
      handleImgSuccess(file){
        this.form.machinePhotos = file.thumb;
        this.$refs.form.clearValidate('machinePhotos');
      },
    /**
     * @Author: likk
     * @description: 发布
     * @param {*}
     * @return {*}
      */    
      handleSave(){
        this.$refs.form.validate((valid) => {
          if (valid) {
            let params = this.form;
            // 将选中的机具类型id 名称一起带回
            params.firstMachineId = params.checkedMachine[0];
            params.secondMachineId = params.checkedMachine[1];
            params.machineId = params.checkedMachine[2];
            params.machineName = this.$refs.elCascader.getCheckedNodes()[0].label;
            this.$emit('submit',params);
          }
        })
      },  
      /**
       * @Author: likk
       * @description: 弹框关闭事件
       * @param {*}
       * @return {*}
      */  
      handleClose(){
        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss" scoped>
   
  ::v-deep .upload-box{
    margin-left: -40px;
    .el-upload{
      margin: 0 auto;
      width: 160px;
      height: 160px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      i{
        font-size: 70px;
        color: #018388;
      }
      span{
        line-height: 20px;
        font-size: 20px;
        color: #018388;
        margin-top: 5px;
      }
      .thumb{
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
  .foot{
    text-align: center;
    .el-button{
      font-size: 20px;
      padding: 16px 46px;
      margin: 0 12px;
      &.btn-gray{
        background: #CDCDCD;
        border-color: #CDCDCD;
      }
    }
  }
  ::v-deep .el-form{
    .el-form-item{
      width: 100% !important;
    }
  }

</style>